import { put, call, takeEvery } from 'typed-redux-saga';

import GoldGateway from '~apis/gold';
import combinedActions from '~redux/combinedActions';
import { store } from '~redux/store';

import { GatewayResponseStatus } from '~types/gateway';
import { SagaWatcherReturnType } from '~types/saga';

import { ErrorMessages } from '~utils/constants';
import { FundTypeEnum, InventoryActionEnum } from '~utils/enums';

export default function* watchGetInventoryDeliveredListing(api: GoldGateway): SagaWatcherReturnType {
    yield takeEvery('gold/goldGetGoldInventoryReportDeliveredListingAttempt', handleGetInventoryDeliveredListing, api);
}

function* handleGetInventoryDeliveredListing(api: GoldGateway) {
    const reduxState = store.getState();
    const authToken = reduxState.auth.userDetails.authToken;
    const { index, filters: { branchCode, productId, serialNo, fundType } } = reduxState.gold.goldInventoryReport.inventoryDelivered;

    if (!index && index !== 0) {
        yield put(combinedActions.goldGetGoldInventoryReportDeliveredListingFailure(ErrorMessages.GenericRequiredFieldNotFilledIn));
        return;
    }

    const response = yield* call([api, api.getInventoryTransfers], {
        authToken,
        index,
        action: InventoryActionEnum.TransferFrom,
        branchCode: branchCode || undefined,
        productId: productId || undefined,
        serialNo: serialNo || undefined,
        fundType: FundTypeEnum[fundType as keyof typeof FundTypeEnum] || undefined,

    });

    if (response.status === GatewayResponseStatus.Error) {
        yield put(combinedActions.goldGetGoldInventoryReportDeliveredListingFailure(response.message || ErrorMessages.GenericError));
        return;
    }

    if (response.status === GatewayResponseStatus.Success) {
        yield put(combinedActions.goldGetGoldInventoryReportDeliveredListingSuccess(response.data));
    }
}
